import React, {useEffect,useContext,useState} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import {custom, input} from "../../utils/linker";
import {ComponentContext} from "../../contexts";
import reactionCombiner from "../../utils/reactionCombiner";
import moment from "moment";
import DateField from "../Helpers/DateField";
import DataExporter from "../Helpers/DataExporter";

function Date(props) {

  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore=useContext(ComponentContext);
  let _ref=null;
  const [comb,setComb]=useState(new reactionCombiner());

  const isMultiple=()=>{
    const ret=typeof props.index !== "undefined";
    return ret;
  };


  const getValue=()=>{
    if(isMultiple()) {
      return compStore.data[props.index];
    } else {
      return compStore.data;
    }
  };

  useEffect(() => {
    // mount
    runInAction(()=>{
      /*console.log("TRY INIT DATE", props);
      if(!isMultiple()) {
        console.log("GET_VALUE SINGLE", toJS(getValue()), toJS(compStore));
      } else {
        console.log("GET_VALUE MULTIPLE", toJS(getValue()));
      }*/
      if(!getValue() && !isMultiple()) {
        getValue()[getTitleField()]="";
        getValue().str_value="";
      }
      if(getValue() && getValue()[getTitleField()] && !getValue().str_value) {
        const parsed=moment(getValue()[getTitleField()], "YYYY-MM-DD HH:mm:ss");
        getValue().str_value=parsed.format(compStore.options.useTime?"DD.MM.YYYY HH:mm:ss":"DD.MM.YYYY")
      }
    });

    comb.addReaction(()=>{
      return compStore.data[props.index]?compStore.data[props.index].focus:0;
    },(focus)=>{
      setTimeout(()=>{
        if(focus && _ref) {
          _ref.focus();
          runInAction(()=>{
            compStore.data[props.index].focus=0;
          });
        }
      },0);
    },{ fireImmediately:true });

    return () => {
      // unmount
      comb.clear();
    }
  }, []);

  const newRef=(ref)=>{
    _ref=ref;
  };

  const getTitleField=()=>{
    if(props.fieldSettings && props.fieldSettings.title_field) {
      return props.fieldSettings.title_field;
    }
    return "value";
  };


  if(!getValue()) {
    return null;
  }


  return (
    <div>
      <DateField use_time={compStore.options.useTime} inputRef={(ref)=>{ newRef(ref); }} saveValueLinker={custom(getValue(),getTitleField()).linker} {...custom(getValue(),"str_value")} placeholder={compStore.options.placeholder} />
      {!isMultiple()?<DataExporter exportIndex="value" plain={true} />:null}
    </div>
  )
};

Date.defaultProps = {};

Date.propTypes = {
  index:PropTypes.number,
}

export default observer(Date);
